const translations = {
  'classesDeIngles.seo.title': 'Clases y cursos de inglés intensivos y económicos en Barcelona',
  'classesDeIngles.seo.description':
    '¡Cursos de inglés a 50€ al mes! Grupos reducidos, aulas modernas, clases amenas y divertidas, todo en el centro de Barcelona.',
};

export default translations;
